@if (display == 'date') {
  {{ lastMod | async  |  cldate }}
}
@if (display == 'numberOfFiles') {
  {{fileNo | async }}
}
